import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './RegionalProjects.css';
import { FEATURED_REGIONAL_PROJECTS } from '../data/projectsData';
import { FaMapMarkerAlt, FaCheckCircle, FaRulerCombined, FaBed, FaPhoneAlt } from 'react-icons/fa';

export default function RegionalProjects() {
  const [selectedCity, setSelectedCity] = useState("All");

  const citiesList = ["All", "Madurai", "Coimbatore", "Thanjavur", "Kumbakonam", "Trichy"];

  const filteredProjects = selectedCity === "All"
    ? FEATURED_REGIONAL_PROJECTS
    : FEATURED_REGIONAL_PROJECTS.filter(p => p.city === selectedCity);

  return (
    <section id="regional-projects" className="regional-projects-section" aria-label="Regional Featured Projects">
      <div className="container">
        {/* Section Header */}
        <div className="section-header" data-aos="fade-up">
          <span className="subtitle">REGIONAL PORTFOLIO</span>
          <h2>Ongoing & Landmark Projects <span>Across Tamil Nadu</span></h2>
          <p>
            Explore our premier residential developments, luxury villas, and turnkey constructions engineered with utmost structural precision in Madurai, Coimbatore, Thanjavur, Kumbakonam, and Trichy.
          </p>
        </div>

        {/* Region Filter Navigation */}
        <div className="region-filter-tabs" data-aos="fade-up" data-aos-delay="50">
          {citiesList.map(city => (
            <button
              key={city}
              type="button"
              className={`filter-tab-btn ${selectedCity === city ? "active" : ""}`}
              onClick={() => setSelectedCity(city)}
            >
              {city === "All" ? "🏢 All Regions" : `📍 ${city}`}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="regional-projects-grid">
          {filteredProjects.map((project, idx) => (
            <article
              key={project.id}
              className="project-showcase-card"
              data-aos="fade-up"
              data-aos-delay={idx * 50}
            >
              {/* Media Thumbnail */}
              <div className="card-media-wrapper">
                <img
                  src={project.image}
                  alt={`${project.title} - ${project.subLocation}, ${project.city}`}
                  loading="lazy"
                  className="card-project-img"
                />
                <div className="card-media-overlay"></div>
                
                {/* Location Pill */}
                <div className="card-location-badge">
                  <FaMapMarkerAlt /> {project.subLocation}, {project.city}
                </div>

                {/* Status Indicator */}
                <div className="card-status-pill">
                  <span className="pulse-dot"></span>
                  {project.status}
                </div>
              </div>

              {/* Card Body */}
              <div className="card-body-content">
                <div className="card-header-row">
                  <span className="card-category-tag">{project.category}</span>
                  <div className="card-dimension-tags">
                    <span className="dimension-badge"><FaBed /> {project.bhk}</span>
                    <span className="dimension-badge"><FaRulerCombined /> {project.area}</span>
                  </div>
                </div>

                <h3 className="card-project-title">{project.title}</h3>
                <p className="card-description">{project.description}</p>

                {/* Progress Bar */}
                <div className="project-progress-wrap">
                  <div className="progress-label-row">
                    <span>Construction Progress</span>
                    <span className="progress-percentage">{project.progress}%</span>
                  </div>
                  <div className="progress-track">
                    <div 
                      className="progress-fill" 
                      style={{ width: `${project.progress}%` }}
                    ></div>
                  </div>
                </div>

                {/* Key Architectural Specs */}
                <div className="card-specs-list">
                  {project.specs.map((spec, sIdx) => (
                    <span key={sIdx} className="spec-item">
                      <FaCheckCircle className="spec-check" /> {spec}
                    </span>
                  ))}
                </div>

                {/* Card CTA Footer */}
                <div className="card-footer-actions">
                  <a href="#enquiry" className="card-enquire-btn">
                    Enquire Project
                  </a>
                  <a href="tel:+919842943377" className="card-call-btn" title="Call Project Advisor">
                    <FaPhoneAlt /> Call
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Regional Footnote Banner */}
        <div className="regional-summary-banner" data-aos="fade-up">
          <div className="summary-banner-content">
            <div className="summary-stat-box">
              <span className="summary-number">400+</span>
              <span className="summary-label">Completed Landmarks</span>
            </div>
            <div className="summary-divider"></div>
            <div className="summary-stat-box">
              <span className="summary-number">15+</span>
              <span className="summary-label">Districts in Tamil Nadu</span>
            </div>
            <div className="summary-divider"></div>
            <div className="summary-stat-box">
              <span className="summary-number">100%</span>
              <span className="summary-label">Quality Assured Handover</span>
            </div>
          </div>
          <div className="summary-cta-wrap">
            <Link to="/contact" className="summary-cta-btn">
              Schedule Free Site Consultation &rarr;
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

